import { NotificationItem } from "../types";
import { normalizeEnvelopeFromApiRecord } from "./normalizeIncomingEnvelope";

export const mapApiNotificationRecordsToItems = (
  rows: Record<string, unknown>[]
): NotificationItem[] => {
  return rows.reduce<NotificationItem[]>((acc, row) => {
    const normalized = normalizeEnvelopeFromApiRecord(row);
    if (!normalized) {
      return acc;
    }

    const isRead = row.read_at !== null && row.read_at !== undefined;
    acc.push({
      ...normalized,
      isRead,
    });

    return acc;
  }, []);
};
